/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IBazzarvoiceWidget contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum widgetType {
    reviews = 'reviews',
    questions = 'questions',
    rating_summary = 'rating_summary',
    inline_rating = 'inline_rating'
}

export interface IBazzarvoiceWidgetConfig extends Msdyn365.IModuleConfig {
    widgetType?: widgetType;
}

export interface IBazzarvoiceWidgetResources {}

export interface IBazzarvoiceWidgetProps<T> extends Msdyn365.IModule<T> {
    resources: IBazzarvoiceWidgetResources;
    config: IBazzarvoiceWidgetConfig;
}
